import { MotorStatusMdl } from './MotorStatusMdl';

export class MotorPromoReqMdl
 {
   public PROMOCODE: string;
   public INSURED_IDNO: string;
   public SEQUENCENO: string;
   public CUSTOMID: string;
   public PRODUCTCODE: string;
   public CHASSISNO: string;  
  }

  export class MotorPromoResMdl
  {
    public DICOUNTFLAG: boolean;
    public  DISCOUNT_PER: number;
    public DISCOUNT_FLAT: number;
    public  PROMOID: number;
    public  DISCOUNTTYPE: string;
    public st: MotorStatusMdl=new MotorStatusMdl();
      
  }


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/MotorPromoReqMdl.ts